import { generateAPI } from "../api.generator";

export const shareFeedbackSettings = generateAPI<
  {
    body: {
      feedbackOptions: string;
      message: string;
    };
  },
  any
>("post", "feedback");
